import { ColumnType } from "antd/lib/table";
import { Tooltip } from "antd";
import { MdCancel, MdCheck, MdFastForward, MdFastRewind, MdHistory, MdOutlineSwapHoriz } from "react-icons/md";
import { ContentMd } from "../styles";
import { formatarDataSemTimezone, limitarCaracteres, STATUS_DISABLED } from "../utils";
import { TalhaoHistorico } from "../../../interfaces/Talhao";
import StatusTag from "./StatusTag";

const columns = (
  setIsCancelOperationModal: (args: boolean) => void,
  setIsAnteciparOuProrrogarModal: (args: boolean) => void,
  setAnteciparOuProrrogar: (args: any) => void,
  setIsModalHistoricoOperacao: (args: boolean) => void,
  setPlanoOperacionalOperacaoTalhao: (args: TalhaoHistorico) => void,
  rows: any[],
  hasPermission: (args: string[]) => boolean,
  setIsEncerrarOuReabrirModal: (args: boolean) => void,
  setCodigoEncerrarOuReabrirModal: (args: number | null) => void,
): ColumnType <any>[] => {

  let columnsShow: ColumnType<any>[] = [
    {
      title: "Seq.",
      dataIndex: "index",
      align: "center",
      width: 25,
      render: (value: number) => <span style={{ color: "#2d3436" }}>{value}</span>,
    },
    {
      title: "Planejamento",
      dataIndex: "plano_descricao",
      align: "center",
      width: 80,
      render: (value: string) =>
        <Tooltip title={value}>
          <span style={{ color: "#2d3436" }}>{limitarCaracteres(value, 17) ?? "-"}</span>
        </Tooltip>,
    },
    {
      title: "Operação",
      dataIndex: "operacao_operacao",
      align: "center",
      width: 150,
      render: (value: string) =>
        <Tooltip title={value}>
          <span style={{ color: "#2d3436" }}>{limitarCaracteres(value, 40) ?? "-"}</span>
        </Tooltip>,
    },
    {
      title: "Referência",
      dataIndex: "planoOperacionalReferencia",
      align: "center",
      width: 70,
      render: (value: string, dataValue: any) =>
        value === 'Operação Vinculada' ? <Tooltip title={dataValue?.vinculo}>
          <span style={{ color: "#2d3436" }}>{value ?? "-"}</span>
        </Tooltip> : <span style={{ color: "#2d3436" }}>{value ?? "-"}</span>
      ,
    },
    {
      title: "Carência",
      dataIndex: "carenciaQuantidadeDias",
      align: "center",
      width: 33,
      render: (carenciaQuantidadeDias: number) => <span style={{ color: "#2d3436" }}>{carenciaQuantidadeDias ?? "-"}</span>,
    },
    {
      title: "Programada",
      dataIndex: "dataProgramada",
      align: "center",
      width: 70,
      render: (_: any, dataValue: any) => {
        let data = formatarDataSemTimezone(dataValue?.dataProgramada, false, true);

        if (dataValue?.periodoDataInicio && dataValue?.periodoDataFim) {
          data = `${formatarDataSemTimezone(dataValue?.periodoDataInicio, false, true)} à ${formatarDataSemTimezone(dataValue?.periodoDataFim, false, true)}`;
        }
        return (
          <span style={{ color: "#2d3436" }}>
            {data}
          </span>
        )
      },
    },
    {
      title: "Executada",
      dataIndex: "dataExecucao",
      align: "center",
      width: 45,
      render: (dataExecucao: string) => <span style={{ color: "#2d3436" }}>{formatarDataSemTimezone(dataExecucao, false, true) ?? "-"}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      width: 75,
      render: (status: any, dataValue: any) => (
        <Tooltip
          title={
            dataValue?.possuiVinculoOrdemServico
              ? (
                <div>
                  {dataValue.ordensServico?.map((os: any) => (
                    <div key={os.numero}>
                      O.S.: {os.numero} - {os.areaExecutada?.toFixed(2).replace(".", ",")} ha
                    </div>
                  ))}
                </div>
              )
              : undefined
          }
        >
          <span style={{ display: "block" }}>
            <StatusTag status={status ?? undefined} orderService={dataValue} />
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Ações",
      dataIndex: "sequencia",
      align: "center",
      width: 70,
      render: (_sequencia: number, talhao: any) => {
        let blockButtonCancel = false;
        let operacao: any = null;
        const isDisabledByDate = talhao?.periodoDataInicio && talhao?.periodoDataFim ? true : false;

        const dependentes = rows.filter((item) =>
          item?.operacao_planoOperacionalOperacaoReferenciaId === talhao?.operacao_planoOperacionalOperacaoId
        );
        if (dependentes?.length >= 1) {
          operacao = dependentes[0];
          blockButtonCancel = true;
        }
        return (
          <ContentMd>
            <Tooltip
              title={!hasPermission(['MapaCronograma.CancelarOperacao']) ? "Você não tem permissão para cancelar" : talhao?.possuiVinculoOrdemServico ? `Está operação possui vinculo com a Ordem de Serviço` : blockButtonCancel ? `Esta operação possui vinculo com a sequencia ${operacao?.index} ${operacao?.operacao_operacao}` : "Cancelar"}>
              <span style={{ display: "inline-block" }}><button className="cancel-operation"
                disabled={
                  talhao?.status === "Cancelada"
                  || talhao?.status === "ExecutadaParcialmente"
                  || talhao?.status === "Executada"
                  || blockButtonCancel
                  || talhao?.possuiVinculoOrdemServico
                  || !hasPermission(['MapaCronograma.CancelarOperacao'])
                }
                onClick={() => {
                  if (!hasPermission(['MapaCronograma.CancelarOperacao'])) return;
                  setPlanoOperacionalOperacaoTalhao({
                    ...talhao,
                    operacaoNome: talhao?.dataProgramada
                  });
                  setIsCancelOperationModal(true);
                }}><MdCancel /></button></span>
            </Tooltip>

            <Tooltip title={!hasPermission(['MapaCronograma.AnteciparOperacao']) ? "Você não tem permissão para antecipar" : "Antecipar"}>
              <span style={{ display: "inline-block" }}><button className="previus-operation"
                disabled={!hasPermission(['MapaCronograma.AnteciparOperacao']) || isDisabledByDate || STATUS_DISABLED.includes(talhao?.status)} onClick={() => {
                  if (!hasPermission(['MapaCronograma.AnteciparOperacao'])) return;
                  setAnteciparOuProrrogar({
                    name: "Antecipar",
                    data: talhao?.dataProgramada
                  });
                  setPlanoOperacionalOperacaoTalhao({
                    ...talhao,
                    operacaoNome: talhao?.dataProgramada
                  });

                  setIsAnteciparOuProrrogarModal(true);
                }}><MdFastRewind /></button></span>

            </Tooltip>
            <Tooltip title={!hasPermission(['MapaCronograma.ProrrogarOperacao']) ? "Você não tem permissão para prorrogar" : "Prorrogar"}>
              <span style={{ display: "inline-block" }}><button className="next-operation" disabled={!hasPermission(['MapaCronograma.ProrrogarOperacao']) || isDisabledByDate || STATUS_DISABLED.includes(talhao?.status)} onClick={() => {
                if (!hasPermission(['MapaCronograma.ProrrogarOperacao'])) return;
                setAnteciparOuProrrogar({
                  name: "Prorrogar",
                  data: talhao?.dataProgramada
                });
                setPlanoOperacionalOperacaoTalhao({
                  ...talhao,
                  operacaoNome: talhao?.dataProgramada
                });
                setIsAnteciparOuProrrogarModal(true);
              }}><MdFastForward /></button></span>
            </Tooltip>
            <Tooltip title={talhao?.encerrada ? "Reabrir" : "Encerrar"}>
                  <span style={{ display: "inline-block" }}><button className={talhao?.encerrada ? "swap" : "check"} disabled={talhao?.status !== "ExecutadaParcialmente"} onClick={() => {
                    setIsEncerrarOuReabrirModal(true);
                    setCodigoEncerrarOuReabrirModal(talhao?.encerrada ? 6 : 5);
                    setPlanoOperacionalOperacaoTalhao({
                      ...talhao,
                      operacaoNome: talhao?.dataProgramada
                    });
                  }}>{talhao?.encerrada ? <MdOutlineSwapHoriz /> : <MdCheck />}</button></span>
            </Tooltip>
            <Tooltip title="Ver Histórico da Operação">
              <span style={{ display: "inline-block" }}><button className="view-historic-operation" onClick={() => {
                setPlanoOperacionalOperacaoTalhao({
                  ...talhao,
                  operacaoNome: talhao?.dataProgramada
                });
                setIsModalHistoricoOperacao(true);
              }}><MdHistory /></button></span>
            </Tooltip>
          </ContentMd>
        )
      },
    },
  ];
  return columnsShow;
}

export default columns;
